import { transform } from '@Common/Helpers/CollectionUtils';

export class UrlParser {
    public static parse(url: string): Readonly<HTMLHyperlinkElementUtils & { params: UrlParameters }> {
        const linkElement = document.createElement('a');
        linkElement.href = url;
        return _.assign(linkElement, { params: this.parseParams(linkElement.search) });
    }

    public static parseParams(search: string): UrlParameters {
        return new UrlParameters(
            _.chain(search)
                .trimStart('?')
                .split('&')
                .filter(_.negate(_.isEmpty))
                .map(item => {
                    return item.split('=').map(decodeURIComponent);
                })
                .value() as [string, string][]
        );
    }
}

export class UrlParameters {
    private readonly map: Map<string, { key: string; value: string }>;

    constructor(params: [string, string][]) {
        this.map = new Map(
            params.map(([key, value]) => {
                return [_.toUpper(key), { key, value }] as [string, { key: string; value: string }];
            })
        );
    }

    public has(param: string): boolean {
        return this.map.has(_.toUpper(param));
    }

    public get(param: string): string {
        const bug = this.map.get(_.toUpper(param));
        return bug ? bug.value : undefined;
    }

    public entries(): IterableIterator<[string, string]> {
        return transform(this.map.entries(), ([k, v]) => [v.key, v.value] as [string, string]);
    }
}
